<template>
  <div>
    <!-- 注册方式选择 -->
    <el-dialog class="registrationMethod" :visible.sync="registrationMethod" center title="选择您希望的注册方式" top="0"
               width="800px">
      <div class="flex wayList">
        <div class="guide_a">
          <img src="../../assets/img/login_b.png" alt="">
          <p>将简历文档通过邮箱发送至<br/><span>{{ copyData }}</span><br/>中，由管理员为您注册</p>
          <el-button plain @click="copy" class="wechat-copy" :data-clipboard-text="copyData">邮箱注册</el-button>
        </div>
        <div class="guide_a">
          <img src="../../assets/img/login_c.png" alt="">
          <p>将简历文档上传至本网站 由管理员为您注册</p>
          <el-button plain @click="resumeDelivery">简历投递</el-button>
        </div>
        <div class="guide_a">
          <img src="../../assets/img/login_a.png" alt="">
          <p>根据提示将信息填写完整<br/>点击“注册”<br/>您的工作室即建立完成</p>
          <el-button plain @click="toDoctorR">自主注册</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="registrationMethod" :visible.sync="copyRig" center top="0"
               width="400px">
      <div class="copyRig">
        <img src="../../assets/img/login_d.png" alt="" width="120">
        <p>邮箱账号已复制成功<br/>快把您的简历发送过来吧！</p>
        <p style="color: #FC7B66">包含内容：1.头像 2.简历 3.相关资质证书</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import sysConstant from "@/api/system_constant"
export default {
  name: "commonRes",
  data() {
    return {
      registrationMethod: false,
      copyRig: false,
      copyData: sysConstant.TIPS_CONTACT.EMAIL
    }
  },
  mounted() {
  },
  methods: {
    copy() {
      this.registrationMethod = false
      if (Clipboard.isSupported()) {
        let clipboard = new Clipboard('.wechat-copy');
        clipboard.on('success', e => {
          this.copyRig = true;
          // 释放内存
          clipboard.destroy();
        })
        clipboard.on('error', e => {
          // 不支持复制
          this.$message('该浏览器不支持复制');
          // 释放内存
          clipboard.destroy();
        })
      } else {
        this.$message('该浏览器不支持复制');
      }
    },
    resumeDelivery() {
      this.$router.push({name: 'resumeDelivery'})
    },
    toDoctorR() {
      this.registrationMethod = false
      this.$router.push({name: 'doctorRegist'})
    },
  },

}
</script>

<style lang="scss" scoped>
@import '../../assets/css/commonRes.scss';
</style>
